import { Component, component, property } from '../../../concepts/objects';

const voteRoundDef = {
    name: 'VoteRound',
};

@component(voteRoundDef)
export class VoteRound extends Component {

    public static sort(rounds: Iterable<VoteRound>) {
        return Array.from(rounds).sort((a, b) => a.greaterThan(b) ? 1 : -1);
    }

    @property({ type: 'number' })
    public index!: number;

    @property({ type: 'boolean', default: true })
    public duplicates!: boolean;

    @property({ type: 'number', default: 0 })
    public allocation!: number;

    public get label(): string {
        return `Voting Round #${this.index}`;
    }

    public greaterThan(another: VoteRound): boolean {
        if (this.index > another.index) return true;
        if (this.index < another.index) return false;
        return this.id > another.id;
    }
}
